import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsFilesJob } from "@/models/admin/warrantsFilesJob/warrantsFilesJob"
import {
  IWarrantsFilesJob,
  WarrantsFilesJobStatus,
} from "@/models/admin/warrantsFilesJob/warrantsFilesJob.types"

/**
 * A single `warrants_files_job` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Files_Job` row; kept as a narrow type so the
 * parser only depends on the columns it actually reads.
 */
export type WarrantsFilesJobRaw = {
  id: number
  status: string
  error_message?: string | null
  started_at: string
  ended_at?: string | null
  created_at: string
}

export const WarrantsFilesJobParser: IParser<
  IWarrantsFilesJob,
  WarrantsFilesJobRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsFilesJob(
        data.id,
        data.status as WarrantsFilesJobStatus,
        data.error_message ?? null,
        dayjsUTC(data.started_at),
        data.ended_at ? dayjsUTC(data.ended_at) : null,
        dayjsUTC(data.created_at),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
